// extracted by mini-css-extract-plugin
export default {"form":"forgot-password_form__8jHLk","link":"forgot-password_link__4o5Ic"};